import { FC } from "react";
import { Link } from "react-router";
import Button from "./ui/Button";

interface CookieConsentProps {
  onAccept: () => void;
}

const CookieConsent: FC<CookieConsentProps> = ({ onAccept }) => {
  return (
    <div
      className="fixed z-[99999] w-[calc(100%-2rem)] max-w-[390px] p-5 rounded-[20px] border border-white left-4 right-4 md:left-auto md:w-[390px]"
      style={{
        background: "#FFFFFF80",
        backdropFilter: "blur(50px)",
        boxShadow:
          "0px 2px 20px 10px rgba(0, 0, 0, 0.10), inset 0px 1px 20px rgba(0, 0, 0, 0.08)",
        bottom: "5%",
        WebkitBackdropFilter: "blur(50px)"
      }}
    >
      <div className="flex flex-col gap-[15px]">
        <p className="text-[#232323] text-[13px] font-medium tracking-[-0.26px] leading-normal">
          Мы используем файлы cookie для повышения удобства пользования сайтом.
          Продолжая использовать сайт, вы подтверждаете согласие на обработку
          файлов cookie и других пользовательских данных в соответствии с{" "}
          <Link to="/about/privacy" className="!text-[#3256F3] !underline">
            Политикой конфиденциальности
          </Link>
        </p>
        <Button
          onClick={onAccept}
          className="!text-[14px] !font-semibold !tracking-[-0.28px] !py-[15px] mt-[15px] !rounded-[15px]"
        >
          Принять
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;